/* OtoVision Engine (Updated Car Titles) */
(function() {
  'use strict';
  
  window.OtoVision = window.OtoVision || {};

  var zenixImg = "https://cdn.shopify.com/s/files/1/0600/7514/7334/t/8/assets/innova-zenix-side.png?v=1785827780";
  var civicImg = "https://cdn.shopify.com/s/files/1/0600/7514/7334/t/8/assets/honda-civic-typer-side.png?v=1785834989";
  var pajeroImg = "https://cdn.shopify.com/s/files/1/0600/7514/7334/t/8/assets/pajero-sport-side.png?v=1785835342";
  var bmwImg = "https://cdn.shopify.com/s/files/1/0600/7514/7334/t/8/assets/bmw-3series-g20-side.png?v=1785835555";
  var te37GoldImg = "https://cdn.shopify.com/s/files/1/0600/7514/7334/t/8/assets/velg-volk-te37-gold.png?v=1785828319";
  var vossenGoldImg = "https://cdn.shopify.com/s/files/1/0600/7514/7334/t/8/assets/velg-vossen-forged-gold.png?v=1785835939";
  var civicGlbUrl = "https://cdn.shopify.com/s/files/1/0600/7514/7334/t/8/assets/honda-civic-type-r.glb?v=1785838176";
  var bmwGlbUrl = "https://cdn.shopify.com/s/files/1/0600/7514/7334/t/8/assets/bmw-3series-320i.glb?v=1785842279";

  OtoVision.Cars = {
    'bmw_g20': {
      name: 'BMW 3 Series',
      pcd: '5x112',
      img: bmwImg,
      glbUrl: bmwGlbUrl,
      frontX: 18.2, frontY: 62.5,
      rearX: 79.8, rearY: 62.5
    },
    'civic': {
      name: 'Honda Civic Type R',
      pcd: '5x120',
      img: civicImg,
      glbUrl: civicGlbUrl,
      frontX: 20.2, frontY: 62.0,
      rearX: 79.5, rearY: 62.0
    },
    'zenix': {
      name: 'Toyota Innova Zenix',
      pcd: '5x114.3',
      img: zenixImg,
      glbUrl: '',
      frontX: 20.0, frontY: 57.5,
      rearX: 79.5, rearY: 57.5
    },
    'pajero': {
      name: 'Mitsubishi Pajero Sport',
      pcd: '6x139.7',
      img: pajeroImg,
      glbUrl: '',
      frontX: 18.8, frontY: 59.0,
      rearX: 80.8, rearY: 59.0
    }
  };

  OtoVision.State = {
    carId: 'bmw_g20',
    velgName: 'Volk Racing TE37 Gold Original',
    velgImg: te37GoldImg,
    carBodyColorFilter: 'none',
    velgScale: 1.0,
    is3dMode: false
  };

  OtoVision.init = function() {
    console.log("OtoVision Engine Loaded...");
    this.bindEvents();
    this.selectCar('bmw_g20');
    this.selectWheel('Volk Racing TE37 Gold Original', te37GoldImg);
    this.enableDragSupport();
  };

  OtoVision.bindEvents = function() {
    var self = this;

    // Car Selector
    document.querySelectorAll('.otovision-car-card').forEach(function(card) {
      card.addEventListener('click', function() {
        document.querySelectorAll('.otovision-car-card').forEach(function(c) { c.classList.remove('active'); });
        card.classList.add('active');

        var cid = card.getAttribute('data-car-id');
        self.selectCar(cid);
      });
    });

    // Mode Toggle Buttons
    var mode2dBtn = document.getElementById('otoVisionMode2D');
    var mode3dBtn = document.getElementById('otoVisionMode3D');

    if (mode2dBtn) mode2dBtn.addEventListener('click', function() { self.toggleViewMode(false); });
    if (mode3dBtn) mode3dBtn.addEventListener('click', function() { self.toggleViewMode(true); });

    // CAR BODY COLOR PICKER CLICK EVENTS (2D + 3D TARGETED BODY PAINT)
    document.querySelectorAll('.otovision-body-swatch').forEach(function(swatch) {
      swatch.addEventListener('click', function() {
        document.querySelectorAll('.otovision-body-swatch').forEach(function(s) { s.classList.remove('active'); });
        swatch.classList.add('active');

        var filter = swatch.getAttribute('data-body-filter');
        self.changeCarBodyColor(filter);
      });
    });

    // Wheel Selection
    document.querySelectorAll('.otovision-wheel-option').forEach(function(item) {
      item.addEventListener('click', function() {
        var wid = item.getAttribute('data-wheel-id');
        if (window.OtoVisionWheelManager) {
          window.OtoVisionWheelManager.applyWheelAsset(wid);
        }
      });
    });

    // Quick Zoom Buttons
    var btnUp = document.getElementById('otoVisionScaleUp');
    var btnDown = document.getElementById('otoVisionScaleDown');
    if (btnUp) btnUp.addEventListener('click', function() { self.adjustScale(0.05); });
    if (btnDown) btnDown.addEventListener('click', function() { self.adjustScale(-0.05); });
  };

  OtoVision.selectCar = function(carId) {
    var car = this.Cars[carId];
    if (!car) return;

    this.State.carId = carId;

    var carImg = document.getElementById('otoVisionStageCarImg');
    if (carImg) {
      carImg.src = car.img;
      carImg.style.filter = this.State.carBodyColorFilter;
    }

    // Switch 3D Model GLB URL if available
    var mvEl = document.getElementById('otoVision3DModelViewer');
    if (mvEl && car.glbUrl) {
      mvEl.setAttribute('src', car.glbUrl);
    }

    // AUTO-SNAP WHEEL HUBS PERFECTLY
    var frontHub = document.getElementById('otoVisionFrontHub');
    var rearHub = document.getElementById('otoVisionRearHub');

    if (frontHub) {
      frontHub.style.left = car.frontX + '%';
      frontHub.style.top = car.frontY + '%';
    }
    if (rearHub) {
      rearHub.style.left = car.rearX + '%';
      rearHub.style.top = car.rearY + '%';
    }

    var titleEl = document.getElementById('otoVisionSummaryCarTitle');
    if (titleEl) titleEl.innerText = car.name + ' (' + car.pcd + ')';
  };

  OtoVision.toggleViewMode = function(is3D) {
    this.State.is3dMode = is3D;
    var stage2D = document.getElementById('otoVisionStage2D');
    var stage3D = document.getElementById('otoVisionStage3D');

    if (is3D) {
      if (stage2D) stage2D.style.display = 'none';
      if (stage3D) stage3D.style.display = 'block';
    } else {
      if (stage3D) stage3D.style.display = 'none';
      if (stage2D) stage2D.style.display = 'flex';
    }
  };

  OtoVision.changeCarBodyColor = function(filterVal) {
    var carImg = document.getElementById('otoVisionStageCarImg');
    var filterCss = 'none';
    var rgbaColor = [0.0, 0.06, 0.62, 1.0]; // Default BMW Blue

    if (filterVal === 'none') {
      filterCss = 'none';
      rgbaColor = [0.95, 0.95, 0.95, 1]; // Alpine White
    }
    if (filterVal === 'black') {
      filterCss = 'brightness(0.38) contrast(1.5)';
      rgbaColor = [0.03, 0.03, 0.03, 1];
    }
    if (filterVal === 'red') {
      filterCss = 'hue-rotate(330deg) saturate(3.5) brightness(0.9)';
      rgbaColor = [0.85, 0.05, 0.05, 1];
    }
    if (filterVal === 'blue') {
      filterCss = 'hue-rotate(180deg) saturate(3.0) brightness(0.9)';
      rgbaColor = [0.0, 0.1, 0.7, 1];
    }
    if (filterVal === 'yellow') {
      filterCss = 'hue-rotate(45deg) saturate(4.0) brightness(1.15)';
      rgbaColor = [0.95, 0.75, 0.05, 1];
    }
    if (filterVal === 'green') {
      filterCss = 'hue-rotate(100deg) saturate(3.0) brightness(0.85)';
      rgbaColor = [0.05, 0.55, 0.15, 1];
    }
    if (filterVal === 'orange') {
      filterCss = 'hue-rotate(20deg) saturate(4.0) brightness(1.0)';
      rgbaColor = [0.95, 0.35, 0.05, 1];
    }
    if (filterVal === 'purple') {
      filterCss = 'hue-rotate(240deg) saturate(3.0) brightness(0.85)';
      rgbaColor = [0.45, 0.05, 0.75, 1];
    }
    if (filterVal === 'grey') {
      filterCss = 'grayscale(100%) brightness(0.7) contrast(1.2)';
      rgbaColor = [0.35, 0.35, 0.35, 1];
    }
    if (filterVal === 'pink') {
      filterCss = 'hue-rotate(300deg) saturate(2.5) brightness(1.1)';
      rgbaColor = [0.95, 0.4, 0.65, 1];
    }
    if (filterVal === 'bronze') {
      filterCss = 'hue-rotate(15deg) saturate(2.0) brightness(0.65)';
      rgbaColor = [0.55, 0.35, 0.15, 1];
    }
    if (filterVal === 'cyan') {
      filterCss = 'hue-rotate(150deg) saturate(3.5) brightness(1.0)';
      rgbaColor = [0.05, 0.75, 0.85, 1];
    }

    this.State.carBodyColorFilter = filterCss;
    if (carImg) carImg.style.filter = filterCss;

    // TARGET ONLY EXCLUSIVE BODY PAINT MATERIAL
    var mvEl = document.getElementById('otoVision3DModelViewer');
    if (mvEl && mvEl.model && mvEl.model.materials) {
      try {
        mvEl.model.materials.forEach(function(mat) {
          var matName = (mat.name || '').toLowerCase();
          if (matName === 'bmwcarpaint1' || matName.includes('civictyper_paint') || matName === 'paint' || matName === 'body_paint') {
            if (mat.pbrMetallicRoughness) {
              mat.pbrMetallicRoughness.setBaseColorFactor(rgbaColor);
            }
          }
        });
      } catch (e) {
        console.log("3D color swap note:", e);
      }
    }
  };

  OtoVision.selectWheel = function(name, img) {
    this.State.velgName = name;
    this.State.velgImg = img;

    var frontHub = document.getElementById('otoVisionFrontHub');
    var rearHub = document.getElementById('otoVisionRearHub');

    if (img === 'oem') {
      if (frontHub) {
        frontHub.style.display = 'none';
        frontHub.style.opacity = '0';
      }
      if (rearHub) {
        rearHub.style.display = 'none';
        rearHub.style.opacity = '0';
      }
    } else {
      if (frontHub && rearHub) {
        frontHub.style.display = 'block';
        rearHub.style.display = 'block';
        frontHub.style.opacity = '1';
        rearHub.style.opacity = '1';
        frontHub.src = img;
        rearHub.src = img;
      }
    }
  };

  OtoVision.adjustScale = function(delta) {
    this.State.velgScale += delta;
    if (this.State.velgScale < 0.5) this.State.velgScale = 0.5;
    if (this.State.velgScale > 1.8) this.State.velgScale = 1.8;

    var frontHub = document.getElementById('otoVisionFrontHub');
    var rearHub = document.getElementById('otoVisionRearHub');
    var scaleStr = 'scale(' + this.State.velgScale + ')';

    if (frontHub && rearHub) {
      frontHub.style.transform = scaleStr;
      rearHub.style.transform = scaleStr;
    }
  };

  // DRAG & TOUCH SUPPORT
  OtoVision.enableDragSupport = function() {
    var hubs = document.querySelectorAll('.otovision-wheel-hub');
    hubs.forEach(function(hub) {
      var isDragging = false;
      var startX, startY, initialLeft, initialTop;

      function startDrag(e) {
        isDragging = true;
        var clientX = e.clientX || (e.touches && e.touches[0].clientX);
        var clientY = e.clientY || (e.touches && e.touches[0].clientY);

        startX = clientX;
        startY = clientY;

        var rect = hub.getBoundingClientRect();
        var parentRect = hub.parentElement.getBoundingClientRect();

        initialLeft = rect.left - parentRect.left;
        initialTop = rect.top - parentRect.top;
      }

      function doDrag(e) {
        if (!isDragging) return;
        e.preventDefault();
        var clientX = e.clientX || (e.touches && e.touches[0].clientX);
        var clientY = e.clientY || (e.touches && e.touches[0].clientY);

        var dx = clientX - startX;
        var dy = clientY - startY;

        var parentRect = hub.parentElement.getBoundingClientRect();
        var newLeftPct = ((initialLeft + dx) / parentRect.width) * 100;
        var newTopPct = ((initialTop + dy) / parentRect.height) * 100;

        hub.style.left = newLeftPct + '%';
        hub.style.top = newTopPct + '%';
      }

      function stopDrag() {
        isDragging = false;
      }

      hub.addEventListener('mousedown', startDrag);
      hub.addEventListener('touchstart', startDrag, { passive: false });

      window.addEventListener('mousemove', doDrag);
      window.addEventListener('touchmove', doDrag, { passive: false });

      window.addEventListener('mouseup', stopDrag);
      window.addEventListener('touchend', stopDrag);
    });
  };

  OtoVision.orderWhatsApp = function(csName, phoneNum) {
    var car = this.Cars[this.State.carId];
    var carName = car ? car.name : 'Mobil Otomax';
    var velgName = this.State.velgName;

    var msg = `Halo ${csName}, saya ingin konsultasi & beli Velg dari Game Tuning Studio OtoVision:%0A` +
              `- Mobil Terpilih: ${encodeURIComponent(carName)}%0A` +
              `- Model Velg Terpilih: ${encodeURIComponent(velgName)}%0A` +
              `Mohon info ketersediaan stok & pilihan PCD yang cocok di Otomax Store!`;

    window.open(`https://api.whatsapp.com/send?phone=${phoneNum}&text=${msg}`, '_blank');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { OtoVision.init(); });
  } else {
    OtoVision.init();
  }
})();
